<template>
  <div class="content">
    <card class="text-left">
      <div class="row">
        <div v-for="image in images" class="col-sm-3">
          <img :src="image" />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          {{ contents }}
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <a @click="goSchedulePage()">스케줄 ID : {{ scheduleId }}</a>
        </div>
      </div>
    </card>
    <card class="text-left">
      <div class="row">
        <label class="col-sm-2 col-form-label">팬로그 ID</label>
        <div class="col-sm-3">
          <base-input>
            <p class="form-control-static">{{ fanLogId }} ({{ idHash }})</p>
          </base-input>
        </div>
        <base-button class="update-button col-sm-3" @click.prevent="goSharePage" type="confirm">공유페이지</base-button>
      </div>
      <div class="row">
        <label class="col-md-2 col-form-label key">작성자</label>

        <label class="col-md-10 col-form-label value"
          ><a class="pointer" @click="goUserDetail(userId)">{{ nickname }}({{ userId }})</a></label
        >
      </div>
      <div class="row">
        <label class="col-md-2 col-form-label key">팬로그 지정일자</label>

        <label class="col-md-10 col-form-label value">{{ displayTime }}</label>
      </div>
      <div class="row">
        <label class="col-md-2 col-form-label key">팬로그 작성일자</label>

        <label class="col-md-10 col-form-label value">{{ regTime }}</label>
      </div>
      <div class="row">
        <label class="col-md-2 col-form-label key">공개여부</label>

        <label class="col-md-10 col-form-label value">{{ accessLevelName }}</label>
      </div>
    </card>
    <div class="row actions">
      <div v-if="state !== -1" class="col-md-2">
        <base-button class="btn-danger col-md-12" @click="deleteFanLog" type="success">삭제</base-button>
      </div>
      <div v-if="state !== 0" class="col-md-2">
        <base-button class="btn-danger col-md-12" @click="hideFanLog" type="success">숨김</base-button>
      </div>
      <div v-if="state !== 1" class="col-md-2">
        <base-button class="col-md-12" @click="showFanLog" type="success">표시</base-button>
      </div>
      <div v-if="accessLevel === 0" class="col-md-2">
        <base-button class="col-md-12" @click="showModal" type="success">추천노출</base-button>
      </div>
      <div v-if="isHot === 0 && accessLevel === 0" class="col-md-2">
        <base-button class="col-md-12" @click="setHotFanLog" type="success">HOT 부여</base-button>
      </div>
      <div v-if="isHot === 1 && accessLevel === 0" class="col-md-2">
        <base-button class="btn-danger col-md-12" @click="unsetHotFanLog" type="success">HOT 부여 취소</base-button>
      </div>
      <div v-if="contents !== null && contents.length > 0 && accessLevel === 0" class="col-md-2">
        <base-button class="col-md-12" @click="sendNotification" type="success" :disabled="isPicked">알림전송</base-button>
      </div>
      <div class="col-md-2">
        <base-button class="col-md-12" @click="onClickComments" type="success">댓글 보기</base-button>
      </div>
    </div>
    <div class="pick-section">
      <h4 class="section-title pull-left">띄워준 내역</h4>
      <card>
        <div class="col-md-12">
          <el-table :data="hotFanLogs">
            <el-table-column
              v-for="column in showHistoryColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            ></el-table-column>
          </el-table>
        </div>
      </card>
    </div>
    <FanLogDetailModal
      :key="componentKey"
      :fanLogId="fanLogId"
      :unitId="unitId"
      :shouldShow="fanLogModal.show"
      :onConfirm="onFanLogModal"
      :onCancel="onCancelModal"
    ></FanLogDetailModal>
  </div>
</template>
<script>
import { BaseInput, Card } from "@/components/index";
import { showAPIErrorToast } from "@/util/ErrorUtils";
import swal from "sweetalert2";
import { formatDateTime } from "@/util/DateUtils";
import Endpoints from "@/common/Endpoints";
import FanLogDetailModal from "@/pages/FanLog/FanLogDetailModal";
import { FanLogAccessLevelOptions } from "./FanLogState";
import { BlipNamespace } from "../../common/BlipNamespace";

export default {
  components: {
    BaseInput,
    Card,
    FanLogDetailModal,
  },
  async created() {
    if (!this.$route.query.fanLogId) {
      Toast.error("잘못된접근입니다");
      history.go(-1);
    }

    this.fanLogId = Number(this.$route.query.fanLogId);
    await this.checkPicked();
    await this.getFanLogDetail();
    await this.getRaisedFanLogs();
  },
  data() {
    return {
      componentKey: 0,
      unitId: null,
      contents: null,
      accessLevel: null,
      accessLevelName: null,
      fileIds: [],
      images: [],
      fanLogId: null,
      userId: null,
      scheduleId: null,
      idHash: null,
      nickname: null,
      description: null,
      state: null,
      isHot: null,
      regTime: null,
      displayTime: null,
      reports: [],
      raisedFanLog: [],
      isPicked: true,
      fanLogModal: {
        show: false,
      },
      hotFanLogs: [],
      showHistoryColumns: [
        {
          prop: "startTime",
          label: "시작시간",
          minWidth: 150,
        },
        {
          prop: "endTime",
          label: "종료시간",
          minWidth: 150,
        },
      ],
      showHistory: [],
    };
  },

  methods: {
    async checkPicked() {
      const result = await this.$axios.get(`/adminContents?contentId=${this.fanLogId}&namespace=700`);
      this.isPicked = result.data.data.isPicked;
    },
    async getFanLogDetail() {
      await this.$axios.get(`/fanLogs/${this.fanLogId}`).then((res) => {
        const data = res.data.data;
        this.unitId = data.unitId;
        this.userId = data.userId;
        this.fanLogId = data.id;
        this.userId = data.userId;
        this.nickname = data.nickname;
        this.state = data.state;
        this.isHot = data.isHot;
        this.regTime = formatDateTime(data.regTime);
        this.displayTime = formatDateTime(data.displayTime);
        this.contents = data.contents;
        this.accessLevel = data.accessLevel;
        FanLogAccessLevelOptions.forEach((item) => {
          if (item.value === data.accessLevel) {
            this.accessLevelName = item.label;
          }
        });
        this.scheduleId = data.scheduleId;
        if (this.scheduleId) {
          this.scheduleUrl = `/schedules/scheduleForm?scheduleId=${this.scheduleId}&unitId=${this.unitId}`;
        }
        this.idHash = data.idHash;
        if (data.imageIds) {
          this.fileIds = data.imageIds.split(",");
          this.images = this.fileIds.map((fileId) => `${Endpoints.imageServerUrl}${fileId}`);
        }
      });
    },

    async getRaisedFanLogs() {
      return this.$axios.get(`/fanLogs/${this.fanLogId}/hot`, null).then((res) => {
        this.hotFanLogs = res.data.data;
        this.hotFanLogs = this.hotFanLogs.map((item) => {
          if (item.startTime) {
            item.startTime = formatDateTime(item.startTime);
          }
          if (item.endTime) {
            item.endTime = formatDateTime(item.endTime);
          }
          return item;
        });
      });
    },

    async getReports() {
      try {
        const result = await this.$axios.get(`/collection/${this.collectionId}/reports`);
        this.reports = result.data.data;
      } catch (err) {
        showAPIErrorToast(err);
      }
    },

    async deleteFanLog() {
      swal
        .fire({
          title: "삭제 확인",
          text: `${this.fanLogId} 팬로그 삭제하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "삭제",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              return this.$axios
                .put(`/fanLogs/${this.fanLogId}/state`, {
                  params: { unitId: this.unitId, state: -1 },
                })
                .then((res) => {
                  Toast.success("팬로그가 삭제 되었습니다");
                  this.state = -1;
                });
            } catch (err) {
              Toast.error("팬로그가 삭제 중 에러가 발생하였습니다.");
            }
          }
        });
    },

    async hideFanLog() {
      swal
        .fire({
          title: "숨김 확인",
          text: `${this.fanLogId} 팬로그 숨김하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "숨김",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              return this.$axios
                .put(`/fanLogs/${this.fanLogId}/state`, {
                  params: { unitId: this.unitId, state: 0 },
                })
                .then((res) => {
                  Toast.success("팬로그가 숨김 되었습니다");
                  this.state = 0;
                });
            } catch (err) {
              Toast.error("팬로그가 숨김 중 에러가 발생하였습니다.");
            }
          }
        });
    },
    async showFanLog() {
      swal
        .fire({
          title: "표시 확인",
          text: `${this.fanLogId} 팬로그 표시하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "표시",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              return this.$axios
                .put(`/fanLogs/${this.fanLogId}/state`, {
                  params: { unitId: this.unitId, state: 1 },
                })
                .then((res) => {
                  Toast.success("팬로그가 표시 되었습니다");
                  this.state = 1;
                });
            } catch (err) {
              Toast.error("팬로그가 표시 중 에러가 발생하였습니다.");
            }
          }
        });
    },
    async setHotFanLog() {
      try {
        return this.$axios
          .put(`/fanLogs/${this.fanLogId}/hot`, {
            params: { unitId: this.unitId, isHot: 1 },
          })
          .then((res) => {
            Toast.success("상태가 부여 되었습니다");
            this.isHot = 1;
          });
      } catch (err) {
        Toast.error("에러가 발생하였습니다.");
      }
    },
    async unsetHotFanLog() {
      try {
        return this.$axios
          .put(`/fanLogs/${this.fanLogId}/hot`, {
            params: { unitId: this.unitId, isHot: 0 },
          })
          .then((res) => {
            Toast.success("상태가 부여가 취소 되었습니다");
            this.isHot = 0;
          });
      } catch (err) {
        Toast.error("에러가 발생하였습니다.");
      }
    },

    goSharePage() {
      window.open(`${Endpoints.sharePageUrl}/f/${this.idHash}`);
    },
    onClickComments() {
      this.$router.push(`/comment/all?namespace=${BlipNamespace.FAN_LOG}&unitId=${this.unitId}&contentId=${this.fanLogId}`);
    },
    showModal() {
      if (this.images.length === 0) {
        Toast.error("이미지가 없습니다");
        return;
      }
      if (this.contents === null || this.contents === "") {
        Toast.error("텍스트가 없습니다");
        return;
      }
      this.fanLogModal.show = true;
    },
    onFanLogModal() {},
    onCancelModal() {
      this.fanLogModal.show = false;
      this.getRaisedFanLogs();
    },
    goUserDetail(userId) {
      this.$router.push(`/user/userDetail?userId=${userId}`);
    },
    goSchedulePage() {
      this.$router.push(this.scheduleUrl);
    },
    async sendNotification() {
      swal
        .fire({
          title: "알림 전송 확인",
          text: `해당 팬로그를 알림으로 전송 하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "전송",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              await this.$axios.put(`/fanLogs/${this.fanLogId}/notification`).then((res) => {
                Toast.success("전송완료");
              });
              await this.checkPicked();
            } catch (err) {
              Toast.error("알림 전송 중 에러가 발생하였습니다.");
            }
          }
        });
    },
  },
};
</script>
<style scoped lang="scss">
.actions {
  margin-bottom: 40px;
}
.pointer {
  cursor: pointer;
}
</style>
